var appConfig = ()=>{
  let dev = {
      refreshJwt: 'Interfaces/newjwt',
          host: 'http://127.0.0.1:8080/#/',
          apiURI: 'http://127.0.0.1/photos/photoio/',
      upURI: 'https://showapi.xyxun.top/Uploaders/uploader',
      weixinLoginUrl: encodeURI('https://io.genchor.com/photoio/users/createstate'),
    },
    prod = {
      refreshJwt: 'Interfaces/newjwt',
      host: 'https://show.xyxun.top/#/',
      apiURI: 'https://showapi.xyxun.top/',
      upURI: 'https://showapi.xyxun.top/Uploaders/uploader',
      weixinLoginUrl: encodeURI('https://showapi.xyxun.top/users/createstate'),
    }
  return process.env.NODE_ENV === 'development'? dev : prod
}

export default appConfig()



// WEBPACK FOOTER //
// ./src/common/config.js